import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { StorageService } from '@coin/shared/core/data-access';
import { ContentLanguage, StorageKey } from '@coin/shared/core/util-enums';
import { TranslateService } from '@ngx-translate/core';
import { UpdateNotificationsService } from '@coin/shared/core/util-helpers';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { TranslationViewerBannerComponent } from '@coin/shared/auth/feature';

@Component({
  selector: 'importer-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeaderComponent, RouterOutlet, TranslationViewerBannerComponent]
})
export class AppComponent {
  private readonly translate = inject(TranslateService);
  private readonly storageService = inject(StorageService);

  constructor() {
    inject(UpdateNotificationsService).checkForUpdates();
    this.initializeApp();

    const lang = this.storageService.get(StorageKey.LANGUAGE);
    this.translate.use(lang ?? ContentLanguage.ENGLISH);
  }

  initializeApp(): void {
    this.translate.setDefaultLang(ContentLanguage.ENGLISH);
  }
}
